export default {
  header: {
    earn_points_get_free_rewards: "{{count}} Punkte = Prämien",
    upload_google_review_get_free_rewards: "Bewertung = Prämien",
  },
  reward_card: {
    title: "Erhalte Rabatte und gratis Gerichte",
    earn_points: "Sammel Punkte, jedes Mal wenn du {{threshold}} ausgibst",
  },
  enter_phone_number: {
    title: "Deine Mobilnummer (Kein Festnetz)",
    description:
      "Wir brauchen deine Handynummer, damit wir sicherstellen können, dass du die richtige Person bist, die wir belohnen.",
    place_holder: "Handynummer",
  },
  button: {
    continue: "Weiter",
  },
  product_suggestions: {
    loyalty: {
      title: "Punkte für Rabatte & gratis Essen",
      description: "Erhalte Punkte für Rabatte & gratis Essen",
    },
    googleReview: {
      title: "Bewerte uns & erhalte",
    },
  },
};
